module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-solid-900.woff2?4d986b00ff9ca3828fbd873b097b1b12";